import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingContainer=({loading=false, children})=>{
     return loading?<Box width="100%" align="center"><CircularProgress className="progress" /></Box>:children;
}
export default LoadingContainer;
